import React, { useState, useEffect, useRef } from "react";
import { useFormContext } from "../createworkflow/FormContext";
import { ErrorBoundary } from "../common/ErrorBoundary";
import UploadFilesList from "../../Utils/dataWorkflowFileUpload.json";
import { stage1fileupload , fetchWorkflows } from "../../services/ApiWorkflow";
import { getValue } from "../../Utils/helper";
import { getCookie } from "../../services/DataRequestService";
import Loader from "../common/Loader";
import { toggleErrorVisibility } from "./helper";
import axios from "axios";
import { useQuery, useQueryClient } from "@tanstack/react-query";

import AuthService from "../../services/AuthService";


const { REACT_APP_API_BASE_URL } = process.env

export default function Stage1() {
  const refWorkflowName = useRef();
  const refLblerrWorkflowName = useRef();
  const refWorkflowDescription = useRef();
  const refLblerrWorkflowDescription = useRef();

  const { formData, updateFormData } = useFormContext();
  const [uploadNew, setUploadNew] = useState(false)
  const [uploadExisting, setUploadExisting] = useState(false);
  const queryClient = useQueryClient();


  useEffect(() => {
    if(formData.stage1?.file_upload_option === "new"){
      setUploadNew(true)
      setUploadExisting(false)
    }
      else if(formData.stage1?.file_upload_option === "existing"){
        setUploadExisting(true)
        setUploadNew(false)
      }
    if (!formData?.stage1?.isValid) {
      const { workflow_name, workflow_description, file1, file2, file3, file4 } = formData?.stage1?.errors || {};

      let condition = workflow_name && workflow_name !== "";
      toggleErrorVisibility(condition, refWorkflowName.current, refLblerrWorkflowName.current);
    }
  }, [])

  const handleWorkflowNameChange = (e) => {
    const { name, value } = e.target;

    // Check if workflow name already exists
    if (fetchedworkflows.some((wf) => wf.toLowerCase() === value?.toLowerCase())) {
      //setError("Workflow name already exists!");
      toggleErrorVisibility(true, refWorkflowName.current, refLblerrWorkflowName.current,"Workflow name already exists!" );
      updateFormData("stage1", {
        ...formData.stage1,
        [name]: value
      });
      return;
    }

    let condition = value === "";
    toggleErrorVisibility(condition, refWorkflowName.current, refLblerrWorkflowName.current);

    updateFormData("stage1", {
      ...formData.stage1,
      [name]: value
    });
  };

  const handleWorkflowDescriptionChange = (e) => {
    const { name, value } = e.target;
    updateFormData("stage1", {
      ...formData.stage1,
      [name]: value,
    });
  };


  const handleFileUploadOptionsChange = (e) => {

    const { name, value } = e.target;
    updateFormData("stage1", {
      ...formData.stage1,
      [name]: value,
    });

    if (value === "new") {
      setUploadExisting(false)
      setUploadNew(true)
    }
    else if (value === "existing") {
      setUploadNew(false)
      setUploadExisting(true)
    }
  };

  //React-Query Functions
    // Prefetch existing workflows when input is focused
    const prefetchWorkflows = () => {
      queryClient.prefetchQuery({
        queryKey:  ["workflows", getCookie("sub")],
        queryFn: fetchWorkflows,
      });
    };
  
     // Fetch workflow names (cached if prefetched)
  const { data: fetchedworkflows = [] } = useQuery({
    queryKey:  ["workflows", getCookie("sub")],
    queryFn: fetchWorkflows,
    staleTime: 60000, // Cache for 1 minute
    enabled: false, // Only fetch when needed
  });

  return (
    <ErrorBoundary>
      <div className="row">
        <div className="col-md-12 col-sm-12 col-xs-12">
          <div className="createworkflowtabcontents">
            <div id="stage1">
              <div className="col-md-12 col-sm-12 col-xs-12 padding">
                <div className="col-md-9 col-sm-9 col-xs-12">
                  <div className="form-group1">
                    <label htmlFor="workflow_name">
                      Workflow Name<span>*</span>
                    </label>
                    <input
                      id="workflow_name"
                      type="text"
                      ref={refWorkflowName}
                      name="workflow_name"
                      className="form-control"
                      onFocus={prefetchWorkflows} // Prefetch workflows when user focuses on input
                      placeholder="Enter Here"
                      value={formData.stage1?.workflow_name || ""}
                      onChange={handleWorkflowNameChange}
                    />
                    <label
                      id="lblerr_workflow_name"
                      ref={refLblerrWorkflowName}
                      className="invalid-feedback hidden"
                    >
                      * Required
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-md-9 col-sm-9 col-xs-12">
                <div className="form-group1">
                  <label htmlFor="workflow_description">
                    Workflow Description
                  </label>
                  <textarea
                    id="workflow_description"
                    ref={refWorkflowDescription}
                    name="workflow_description"
                    className="form-control form-control-textarea"
                    rows={5}
                    columns={10}
                    placeholder="Enter Here"
                    value={formData.stage1?.workflow_description || ""}
                    onChange={handleWorkflowDescriptionChange}
                  />
                  <label
                    id="lbl_workflow_description"
                    ref={refLblerrWorkflowDescription}
                    className="invalid-feedback hidden"
                  >
                    * Required
                  </label>
                </div>
              </div>

              <div className="col-md-9 col-sm-9 col-xs-12">
                <input
                  className="relative top-1 cursor-pointer"
                  type="radio"
                  defaultChecked={formData.stage1?.file_upload_option === "new" ? true : false}
                  id="new"
                  name="file_upload_option"
                  value="new" // Add a value for this radio button
                  onChange={handleFileUploadOptionsChange} // Handle value change
                />
                &nbsp;
                <label htmlFor="new" className=" cursor-pointer">Upload New</label>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <input
                  className="relative top-1 cursor-pointer"
                  defaultChecked={formData.stage1?.file_upload_option === "existing" ? true : false}
                  type="radio"
                  name="file_upload_option"
                  id="existing"
                  value="existing" // Add a value for this radio button
                  onChange={handleFileUploadOptionsChange} // Handle value change
                />
                &nbsp;
                <label htmlFor="existing" className=" cursor-pointer">Use Existing</label>
              </div>

              {uploadNew && <FileComponent
                refWorkflowName={refWorkflowName}
                refLblerrWorkflowName={refLblerrWorkflowName}
              />}


              <div className="col-md-9 col-sm-9 col-xs-12">

                {uploadExisting && <ExistingWorkflows />}

                {/* {uploadExisting && <ExistingFileComponent
                refWorkflowName={refWorkflowName}
                refLblerrWorkflowName={refLblerrWorkflowName}
              />} */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
}

function FileComponent({ refWorkflowName, refLblerrWorkflowName }) {
  const refs = useRef([]);
  const { formData, updateFormData } = useFormContext();

  const handleFileUploadClick = async (e) => {
    const { dataset } = e.target;
    const fileInput = document.querySelector(`#${dataset.fileid}`);
    const index = parseInt(dataset.fileid.replace("uploadfile", ""), 10);
    const file = fileInput?.files[0];
    try {
      if (
        !formData.stage1?.workflow_name ||
        formData.stage1?.workflow_name?.length == 0
      ) {
        refWorkflowName.current.focus();
        refLblerrWorkflowName.current.classList.add("visible");
        refLblerrWorkflowName.current.classList.remove("hidden");
        return;
      } else {
        refLblerrWorkflowName.current.classList.add("hidden");
        refLblerrWorkflowName.current.classList.remove("visible");



        if (!fileInput || !fileInput.files.length) {
          fileInput.focus();
          updateFormData("stage1", {
            ...formData.stage1,
            file_upload_status: {
              ...formData.stage1?.file_upload_status,
              [index]: { error: true, success: false, isLoading: false }
            }
          });
          return;
        }

        const userId = getCookie("sub");
        const { id: workflowId } = getValue("session", "formData");
        const sheetName = dataset.sheetname;
       // const sheetName = "";

        // Update loading state
        updateFormData("stage1", {
          ...formData.stage1,
          file_upload_status: {
            ...formData.stage1?.file_upload_status,
            [index]: {
              ...(formData.stage1?.file_upload_status?.[index] || {}),
              isLoading: true
            }
          }
        });

        const response = await stage1fileupload(
          userId,
          workflowId,
          sheetName,
          file
        );

        // Update loading state to false
        updateFormData("stage1", {
          ...formData.stage1,
          file_upload_status: {
            ...formData.stage1?.file_upload_status,
            [index]: {
              ...(formData.stage1?.file_upload_status?.[index] || {}),
              isLoading: false,
              error: false,
              success: response?.status?.toLowerCase() === "success"
            }
          }
        });
      }
    } catch (error) {
      // Update error state in form data
      updateFormData("stage1", {
        ...formData.stage1,
        file_upload_status: {
          ...formData.stage1?.file_upload_status,
          [index]: { error: true, success: false, isLoading: false }
        }
      });
      throw error;
    }
  };

  return (
    <>
      {UploadFilesList?.map((elem, index) => (
        <div
          key={index}
          className="col-md-12 col-sm-12 col-xs-12 fileupload-box "
        >
          <div className="col-md-6 col-sm-6 col-xs-12">
            <div className="form-group1">
              <label htmlFor="file1">{elem.title} { index === 0 ? <span>*</span>:<></>} </label>
              <input
                id={`uploadfile${index}`}
                type="file"
                ref={(el) => (refs.current[index] = el)}
                className={`form-control ${formData.stage1?.file_upload_status?.[index]?.error ? "highlighted" : ""}`}
                accept=".csv, .xlsx, .xls"
                placeholder="No File Choosen"
              />
            </div>
            <div className="choosefilediv">
              <ul>
                <li>
                  <a
                    className="lblinfo"
                    href={elem["sample-file-path"]}
                    download={true}
                  >
                    <iconify-icon icon="material-symbols:download"></iconify-icon>{" "}
                    <span className="lblinfo"> Download Sample File</span>
                  </a>
                </li>
                <li className="lblinfo">(File Type: XLS | XLSX | CSV)</li>
                <li
                  className={`lblerror ${formData.stage1?.file_upload_status?.[index]?.error ? "visible" : "hidden"
                    }`}
                >
                  {" "}
                  * Required
                </li>
                <li
                  className={`lblsuccess ${formData.stage1?.file_upload_status?.[index]?.success ? "visible" : "hidden"
                    }`}
                >
                  {" "}
                  File has been uploaded
                </li>
                {formData.stage1?.file_upload_status?.[index]?.isLoading &&
                  <li><Loader size="small" /></li>
                }
              </ul>
            </div>
          </div>

          <div className="col-md-3 col-sm-3 col-xs-3 uploadbtn-container">
            <div className="form-group1">
              <div className="uploadbtn">
                <a
                  href="#"
                  data-index={index}
                  data-fileid={`uploadfile${index}`}
                  data-sheetname={elem.sheetname}
                  onClick={(e) => {
                    e.preventDefault();
                    handleFileUploadClick(e);
                  }}
                >
                  Upload File{" "}
                  <iconify-icon icon="iconamoon:arrow-right-2-bold"></iconify-icon>
                </a>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
function ExistingFileComponent({ refWorkflowName, refLblerrWorkflowName }) {
  const refs = useRef([]);
  const { formData, updateFormData } = useFormContext();

  const handleFileUploadClick = async (e) => {
    const { dataset } = e.target;
    console.log(dataset);
    const fileInput = document.querySelector(`#${dataset.fileid}`);
    const index = parseInt(dataset.fileid.replace("uploadfile", ""), 10);
    const file = fileInput?.files[0];
    try {
      if (
        !formData.stage1?.workflow_name ||
        formData.stage1?.workflow_name?.length == 0
      ) {
        refWorkflowName.current.focus();
        refLblerrWorkflowName.current.classList.add("visible");
        refLblerrWorkflowName.current.classList.remove("hidden");
        return;
      } else {
        refLblerrWorkflowName.current.classList.add("hidden");
        refLblerrWorkflowName.current.classList.remove("visible");



        if (!fileInput || !fileInput.files.length) {
          fileInput.focus();
          updateFormData("stage1", {
            ...formData.stage1,
            file_upload_status: {
              ...formData.stage1?.file_upload_status,
              [index]: { error: true, success: false, isLoading: false }
            }
          });
          return;
        }

        const userId = getCookie("sub");
        const { id: workflowId } = getValue("session", "formData");
        const sheetName = dataset.sheetname;
        //const sheetName = "";

        // Update loading state
        updateFormData("stage1", {
          ...formData.stage1,
          file_upload_status: {
            ...formData.stage1?.file_upload_status,
            [index]: {
              ...(formData.stage1?.file_upload_status?.[index] || {}),
              isLoading: true
            }
          }
        });

        const response = await stage1fileupload(
          userId,
          workflowId,
          sheetName,
          file
        );

        // Update loading state to false
        updateFormData("stage1", {
          ...formData.stage1,
          file_upload_status: {
            ...formData.stage1?.file_upload_status,
            [index]: {
              ...(formData.stage1?.file_upload_status?.[index] || {}),
              isLoading: false,
              error: false,
              success: response?.status?.toLowerCase() === "success"
            }
          }
        });
      }
    } catch (error) {
      // Update error state in form data
      updateFormData("stage1", {
        ...formData.stage1,
        file_upload_status: {
          ...formData.stage1?.file_upload_status,
          [index]: { error: true, success: false, isLoading: false }
        }
      });
      throw error;
    }
  };

  return (
    <>
      {UploadFilesList?.map((elem, index) => (
        <div
          key={index}
          className="col-md-12 col-sm-12 col-xs-12 fileupload-box "
        >
          <div className="col-md-6 col-sm-6 col-xs-12">
            <div className="form-group1">
              <label htmlFor="file1">{elem.title}</label>
              <input
                id={`uploadfile${index}`}
                type="file"
                ref={(el) => (refs.current[index] = el)}
                className={`form-control ${formData.stage1?.file_upload_status?.[index]?.error ? "highlighted" : ""}`}
                accept=".csv, .xlsx, .xls"
                placeholder="No File Choosen"
              />
            </div>
            <div className="choosefilediv">
              <ul>
                <li>
                  <a
                    className="lblinfo"
                    href={elem["sample-file-path"]}
                    download={true}
                  >
                    <iconify-icon icon="material-symbols:download"></iconify-icon>{" "}
                    <span className="lblinfo"> Download Sample File</span>
                  </a>
                </li>
                <li className="lblinfo">(File Type: XLS | XLSX | CSV)</li>
                <li
                  className={`lblerror ${formData.stage1?.file_upload_status?.[index]?.error ? "visible" : "hidden"
                    }`}
                >
                  {" "}
                  * Required
                </li>
                <li
                  className={`lblsuccess ${formData.stage1?.file_upload_status?.[index]?.success ? "visible" : "hidden"
                    }`}
                >
                  {" "}
                  File has been uploaded
                </li>
                {formData.stage1?.file_upload_status?.[index]?.isLoading &&
                  <li><Loader size="small" /></li>
                }
              </ul>
            </div>
          </div>

          <div className="col-md-3 col-sm-3 col-xs-3 uploadbtn-container">
            <div className="form-group1">
              <div className="uploadbtn">
                <a
                  href="#"
                  data-index={index}
                  data-fileid={`uploadfile${index}`}
                  data-sheetname={elem.sheetname}
                  onClick={(e) => {
                    e.preventDefault();
                    handleFileUploadClick(e);
                  }}
                >
                  Upload Existing{" "}
                  <iconify-icon icon="iconamoon:arrow-right-2-bold"></iconify-icon>
                </a>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}


function ExistingWorkflows() {
  const [existingWorkFlowData, setExtsingWorkflowData] = useState([])
  const { formData, updateFormData } = useFormContext();


  useEffect(() => {
    getTheExistingWorkflow()
  }, [])

  const getTheExistingWorkflow = async () => {
    // const workflow_id = "2dedw3e51-2e06-42ac-80ae-82157c5f467121"
    const workflow_id = formData.id
    const user_id = getCookie("sub")
    try {

      const url = `${REACT_APP_API_BASE_URL}/getSalesDataInfo?user_id=${user_id}`;
      // const url = `http://localhost:8071/getSalesDataInfo=?workflow_id=${workflow_id}&user_id=${user_id}`;

      // Perform the GET request
      const response = await axios.get(url, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Authorization" : AuthService.getAccessToken(),
          "access_token" : AuthService.getAccessToken()
          // access_token: UserService.getToken(), // Replace with your token retrieval function
        },
      });

      // Handle the response
      // console.log(response.data.data);
      setExtsingWorkflowData(response.data.data);


    } catch (error) {
      // Handle errors
      console.error("Error fetching workflows:", error.message);
      throw error;
    }
  }

  const formatDate = (date) => {
    const [day, month, year] = date ? date.split("-") : ""
    return `${year}-${month}-${day}`;
  };

  const addUploadID = (id) => {
    updateFormData("stage1", {
      ...formData.stage1,
      "data_upload_id": id
    });
  }



  return (
    <>
      <h2
        style={{ margin: "vh 0 5vh 0" }}
        className="text-3xl font-bold mb-4 text-center"
      >
        Select Existing
      </h2>
      <div>
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="w-full">
              {/* Forecast Table */}
              <div className="overflow-x-auto">
                <table className="table dataselectiontable-stage1 table-bordered">
                  <thead>
                    <tr className="bg-blue-900 text-white">
                      <th className="border border-gray-300 p-2 bg-[#0C3C54] text-white">
                        Date Of Upload
                      </th>
                      <th className="border border-gray-300 p-2 bg-[#0C3C54] text-white">
                        Data Availablity
                      </th>
                      {/* <th className="border border-gray-300 p-2 bg-[#0C3C54] text-white">
                        Data Available To
                      </th> */}
                      <th className="border border-gray-300 p-2 bg-[#0C3C54] text-white">
                        Select
                      </th>

                    </tr>
                  </thead>
                  <tbody>
                    {existingWorkFlowData && existingWorkFlowData.length > 0 ? (
                      existingWorkFlowData.map((row, index) => (
                        <tr key={index}>
                          <td className="border border-gray-200 p-2">{row.date_of_upload.slice(0, 10)}</td>
                          <td className="border border-gray-200 p-2">{row.start_date} to {row.end_date}</td>
                          {/* <td className="border border-gray-200 p-2">{row.end_date}</td> */}
                          <td className="border border-gray-200 p-2">
                            <input 
                          type="radio" 
                          name="select-upload-id" 
                          defaultChecked={(row.data_upload_id === formData.stage1.data_upload_id)}
                          onChange={() => addUploadID(row.data_upload_id)} />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center p-4">
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  );
}